import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// Login-only guard for standalone pages (e.g. the QR load-sheet viewer) that must be reachable
// by mobile-only roles WITHOUT web-admin (dashboard.view) access. The backend still enforces the
// specific permission + strict company isolation on every request.
export default function LoginOnlyRoute({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f6f7fb]">
        <Loader2 className="w-6 h-6 animate-spin text-indigo-500" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  }
  return children;
}
